<template>
  <section id="wmsselector" :class="$conf.sidebar.enabled ? '' : 'on-edge'">
    <button
      class="button is-light wms-b"
      type="button"
      :disabled="this.$store.getters['isUiDisabled']"
      @click="copyWmsLink">
        {{ this.$store.state.wmsRequest }}
        <b-icon id="copyicon" icon="content-copy"></b-icon>
    </button>
  </section>
</template>

<script>

import log from 'util/log'
import map from 'util/MapEngine'
import { createFullWMSLink } from 'util/helpers'

export default {
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    copyWmsLink: function () {
      if (navigator.clipboard) {
        // createFullWMSLink(url, transparency, layer, time, width, height, epsg, bbox)
        navigator.clipboard.writeText(createFullWMSLink(
          this.$store.state.config.map.layers.baseLayers[this.$store.state.baseLayer].layers[0].url,
          true,
          this.$store.getters['config'].map.layers.baseLayers[this.$store.state.baseLayer].layers[0].params.LAYERS,
          this.$store.getters['mapTime'],
          window.innerWidth,
          window.innerHeight,
          this.$store.state.config.map.layers.baseLayers[this.$store.state.baseLayer].projection.replace(":", "%3A"),
          this.$map.getFit()
        ))
      }
      else {
        console.error("navigator.clipboard is undefined. This might be due to running the webmap locally.")
      }
    }
  }
}

</script>

<style lang="stylus">

section#wmsselector
  position: fixed
  white-space: nowrap
  left: 10px
  top: 10px
  transition: 0.35s
  font-size: 0
  z-index: 1004
  >.wms-b
    >.icon
      margin-left: 5px

@media (min-width: 768px)
  section#wmsselector
    position: absolute
    left: 480px
    top: 10px
    width: auto
    &.on-edge
      left: 360px

</style>
